module.exports = __webpack_public_path__ + "static/media/sm.231883e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sm.png
// module id = 1982
// module chunks = 0